/**
 * Halloween icons — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_seasons`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const halloweenIconsPack: ToilePack = {
    slug: 'halloween-icons',
    category: 'season',
    name: 'Halloween icons',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'pumpkin', label: 'Pumpkin icon', subject: 'A carved pumpkin reduced to one simple glyph, built to read small, isolated on a plain ground'},
        {key: 'ghost', label: 'Ghost icon', subject: 'A little ghost as one simple glyph, built to read small, isolated on a plain ground'},
        {key: 'hat', label: "Witch's hat", subject: "A pointed witch's hat with a buckle as one simple glyph, built to read small, isolated"},
    ],
    styles: [
        {key: 'cute', label: 'Spooky cute', style: 'kawaii spooky illustration, rounded shapes, soft outlines, friendly faces', palette: 'Pastel purple, orange, mint and cream with black accents', framing: 'Centered on a solid background, built to read clean at small size'},
        {key: 'vintage', label: 'Vintage', style: '1950s halloween paper decoration style, halftone grain, slight misregistration', palette: 'Orange, black, cream and a faded green', framing: 'Centered on an aged cream paper background with an even margin'},
        {key: 'bold', label: 'Bold graphic', style: 'bold graphic illustration, thick outlines, high contrast, flat fills', palette: 'Orange, black and white with a single purple', framing: 'Centered on a solid background with a little room around it'},
    ],
    directions: ['a full set of ten icons', 'in outline only', "for a witch's brew menu"],
    directionHint: 'try: a full set of ten icons',
    seo: {
        title: "Halloween Icons: Pumpkin, Ghost, Witch's Hat",
        metaDescription: "Nine halloween icons -- pumpkin, ghost, witch's hat -- in spooky cute, vintage, and bold graphic finishes. Simple glyphs built to read small.",
        h1: "Halloween icons: pumpkin, ghost, and witch's hat glyphs",
        tagline: 'Nine icons, three October marks, three finishes each.',
        intro: "Nine small halloween icon designs, each one simple glyph built to read at 32 pixels: a carved pumpkin, a little ghost, and a witch's hat. Three finishes -- spooky cute, vintage, and bold graphic -- for favicons, app icons, and menus. Ask for a full set of ten icons instead, or an outline-only version, and the same three finishes carry it.",
        useCases: [
            'a website favicon',
            'an app icon set',
            'a spooky menu accent',
            'a sticker sheet icon',
        ],
        faq: [
            {q: 'What does this pack actually look like?', a: "Nine icon designs -- a pumpkin, a ghost, and a witch's hat -- each in spooky cute, vintage, and bold graphic finishes, built to read clean at small size."},
            {q: 'Can I get more than three icons?', a: 'Not in this pack directly, but the direction field can request a full set of ten icons instead, in the same style.'},
            {q: 'What size do these scale down to?', a: 'Each icon is designed to hold its shape down to a 32px favicon, and scales up cleanly for a printed sticker.'},
            {q: 'Can I use these commercially?', a: 'Yes -- the icons are yours to use in personal or commercial projects, including client websites.'},
        ],
    },
}
